"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireDefault(require("react"));
var _tableHeader = require("./tableHeader");
var _tableRow = require("./tableRow");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Table = exports.Table = function Table(_ref) {
  var tableHeader = _ref.tableHeader,
    tableRows = _ref.tableRows,
    customHeader = _ref.customHeader,
    tableClass = _ref.tableClass,
    areAllRowsExpanded = _ref.areAllRowsExpanded;
  var checkForExtraContent = function checkForExtraContent(element) {
    return element.extraContent !== undefined;
  };
  var extraContent = tableRows.some(checkForExtraContent);
  return /*#__PURE__*/_react["default"].createElement("table", {
    className: "wbm-generic-table ".concat(tableClass)
  }, customHeader, /*#__PURE__*/_react["default"].createElement(_tableHeader.TableHeader, {
    tableCells: tableHeader.tableCells,
    dropdownInUse: extraContent
  }), /*#__PURE__*/_react["default"].createElement("tbody", null, tableRows.map(function (tableRow, index) {
    return /*#__PURE__*/_react["default"].createElement(_tableRow.TableRow, {
      tableCells: tableRow.tableCells,
      extraContent: tableRow.extraContent,
      dropdownInUse: extraContent,
      key: "product-".concat(index),
      rowId: tableRow.rowId,
      buttonPressed: tableRow.buttonPressed,
      rowNumber: index,
      rowClass: tableRow.rowClass,
      areAllRowsExpanded: areAllRowsExpanded
    });
  })));
};
//# sourceMappingURL=table.js.map